// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@/assets/css/iview.css'

import Vue from 'vue'
import App from './App'
import router from './router'
import ViewUI from 'view-design'
import store from '@/store'
import 'view-design/dist/styles/iview.css'
import TablePage from '_c/common/table-page.vue'
import config from '@/config'
import common from '@/assets/js/common'
import CustomTree from '_c/custom-tree'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import VueFroala from 'vue-froala-wysiwyg'
import 'froala-editor/js/froala_editor.pkgd.min.js'
import 'froala-editor/js/languages/zh_cn'
import 'froala-editor/css/froala_editor.pkgd.min.css'
import 'font-awesome/css/font-awesome.css'
import 'froala-editor/css/froala_style.min.css'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
Vue.prototype.$common = common

Vue.use(ViewUI)
Vue.use(Viewer)
Viewer.setDefaults({
  navbar: false, // 底部缩略图
  toolbar: false, // 底部工具栏
  button: false, // 右上角按钮
  title: false, // 当前图片标题
  movable: true, // 是否可以移动
  zoomable: true, // 是否可以缩放
  transition: false // 使用CSS3过度
})

Vue.use(VueFroala)

Vue.component('table-page', TablePage)
Vue.component('custom-tree', CustomTree)
Vue.component(VueQrcode.name, VueQrcode)
Vue.component('num-input', Vue.extend({
  extends: ViewUI.Input,
  methods: {
    handleInput (event) {
      this.intercept(event)
      const value = event.target.value
      // this.setCurrentValue(value)
      if (this.isOnComposition) return
      this.$emit('input', value)
    },
    intercept (event) {
      var after = event.target.value
      if (after !== '' && after.substr(0, 1) === '.') {
        after = ''
      }
      after = after.replace(/^0*(0\.|[1-9])/, '$1')// 解决 粘贴不生效
      after = after.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
      after = after.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
      after = after.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
      after = after.replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3')// 只能输入两个小数
      if (after.indexOf('.') < 0 && after !== '') { // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        if (after.substr(0, 1) === '0' && after.length === 2) {
          after = after.substr(1, after.length)
        }
      }
      event.target.value = after
    }
  }
}))

Vue.component('int-input', Vue.extend({
  props: ['max'],
  extends: ViewUI.Input,
  methods: {
    handleInput (event) {
      this.intercept(event)
      const value = event.target.value
      // this.setCurrentValue(value)
      if (this.isOnComposition) return
      this.$emit('input', value)
    },
    intercept (event) {
      var value = event.target.value
      value = value.replace(/^0*(0\.|[1-9])/, '$1')
      if (this.max && Number(value) > this.max) {
        value = this.max
      }
      event.target.value = value > 0 ? parseInt(value) : null
    }
  }
}))

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js